import Image from 'next/image';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import { Card, Form } from 'react-bootstrap';
import {
  IC_DOCTOR,
  IC_LOCATION_DOCTORCARD,
  IC_INPERSON_GREEN,
  IC_RIGHT_ARROW,
  IC_VIDEO_CALL_BLUE_BOX,
  IC_SHARE,
  IC_LEGEND_PNG,
  IC_ICON_PNG,
} from '../../Assets/images';
import useWindowDimensions from '@common/Context/useWindowDimensions';
import { getCardDate, setSlotDetails } from '@common/Utility/common-utils';
import { DoctorCardStyled } from './DoctorCardStyled';
import Highlighter from 'react-highlight-words';
import ShareProduct from 'Epharmacy/ProductDetails/ShareProduct';
import AsterIcons from '../AsterIcons/AsterIcons';
import { useTranslation } from '@common/i18n';

const DoctorCard = (props) => {
  const windowSize = useWindowDimensions();
  const ref = useRef();
  const t = useTranslation();
  const [isClickOnShare, setClickOnShare] = useState(false);
  const [show, setShow] = useState(true);

  React.useEffect(() => {
    const checkIfClickedOutside = (e) => {
      if (isClickOnShare && ref.current && !ref.current.contains(e.target)) {
        setClickOnShare(false);
      }
    };
    document.addEventListener('mousedown', checkIfClickedOutside);
    return () => {
      document.removeEventListener('mousedown', checkIfClickedOutside);
    };
  }, [isClickOnShare]);

  const BoldSuggestion = ({ children }) => <span className="highlight">{children}</span>;
  const getNearestSlotAvailable = () => {
    let slot = '';
    let slotType = '';
    if (props?.availableOnlineSlot && props?.availableOfflineSlot) {
      if (props?.availableOfflineSlot?.slotStart > props?.availableOnlineSlot?.slotStart) {
        slot = props?.availableOnlineSlot;
        slotType = 'VIDEO';
      } else if (props?.availableOnlineSlot?.slotStart > props?.availableOfflineSlot?.slotStart) {
        slot = props?.availableOfflineSlot;
        slotType = 'IN_PERSON';
      } else {
        slot = props?.availableOfflineSlot;
        slotType = 'IN_PERSON';
      }
    } else if (props?.availableOnlineSlot) {
      slot = props?.availableOnlineSlot;
      slotType = 'VIDEO';
    } else if (props?.availableOfflineSlot) {
      slot = props?.availableOfflineSlot;
      slotType = 'IN_PERSON';
    }
    return { slot, slotType };
  };

  return (
    <DoctorCardStyled className={props?.outerCustomClass} isShareable={props?.shareIcon}>
      <Card className={props?.outerCustomClass === 'clinicDetailCard doctorDetailCentered' ? 'clinicDetailCard' : ''}>
        {props?.isFromFacilityDetail && (
          <div className="facilityAsterIconWrapper">
            {props?.doctorTenureLabel !== null && props?.doctorTenureLabel !== undefined && (
              <AsterIcons
                legendsImage={props?.doctorTenureLabel === 'LEGEND' ? IC_LEGEND_PNG : IC_ICON_PNG}
                lengendsText={props?.doctorTenureLabel === 'LEGEND' ? 'legends' : 'icons'}
                customModal={false}
                isFromMyDoctors
              />
            )}
            <div className="addToWishList">
              <Form.Check
                checked={props?.checked}
                onClick={(e) => {
                  e.stopPropagation();
                  props.addRemoveFavorites();
                }}
                type="checkbox"
              />
            </div>
          </div>
        )}
        {windowSize?.width < 781 && !props?.isFromFacilityDetail && (
          <div className={`responsiveIcon`}>
            {props?.doctorTenureLabel !== null && props?.doctorTenureLabel !== undefined && (
              <AsterIcons
                legendsImage={props?.doctorTenureLabel === 'LEGEND' ? IC_LEGEND_PNG : IC_ICON_PNG}
                lengendsText={props?.doctorTenureLabel === 'LEGEND' ? 'legends' : 'icons'}
                infoIcon
                isFromMyDoctors
                customModal={false}
                show={show}
                  onShowChange={(param)=>setShow(param)}
              />
            )}
            {props?.shareIcon ? (
              <div
                className={`rightSideShare ${
                  (props?.doctorTenureLabel === null || props?.doctorTenureLabel === undefined) && 'notIcons'
                }`}
              >
                <div className="addToWishList">
                  <Form.Check
                    checked={props?.checked}
                    onClick={(e) => {
                      e.stopPropagation();
                      props.addRemoveFavorites();
                    }}
                    type="checkbox"
                  />
                </div>
                <div className="share" ref={ref}>
                  <div className="share-tost">
                    <div className="filter">
                      <div className="ic">
                        <Image
                          data-test="shareIcon"
                          src={IC_SHARE.src}
                          width="18px"
                          height="20px"
                          alt="Share"
                          onClick={() => {
                            setClickOnShare(!isClickOnShare);
                          }}
                          style={{ cursor: 'pointer' }}
                        />
                      </div>
                      {isClickOnShare && <ShareProduct doctorName={props?.name} isFromDoctor={true} />}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="addToWishList">
                <Form.Check
                  checked={props?.checked}
                  onClick={(e) => {
                    e.stopPropagation();
                    props.addRemoveFavorites();
                  }}
                  type="checkbox"
                />
              </div>
            )}
          </div>
        )}
        <Card.Body
          className={`doctorCardWrapper ${props?.isFromFacilityDetail && 'doctorcard'} cursor-pointer`}
          onClick={(e) => {
            if (!props?.isDoctorDetails && !props?.quickBooking && !props?.isInstantGPDoctor) {
              sessionStorage.clear();
              props.doctorDetails && props?.doctorDetails(e);
              if (windowSize?.width < 767) {
                props.showDoctorDetails && props.showDoctorDetails(true);
              }
            } else if (props?.isDoctorDetails) {
              if (windowSize?.width < 767) {
                props.showDoctorDetails && props.showDoctorDetails(true);
              }
            } else if (props?.isInstantGPDoctor) {
              props?.navigateToInstantGPScreen();
            }
          }}
        >
          <div
            className={`detailWrapper ${props?.isFromDoctorDetails && 'doctorDetailresponsive'} cursor-pointer`}
            onClick={(e) => {
              e.stopPropagation();
              if (!props?.isDoctorDetails && !props?.quickBooking && !props?.isInstantGPDoctor && show) {
                sessionStorage.clear();
                props?.doctorDetails(e);
                if (windowSize?.width < 767) {
                  props.showDoctorDetails && props?.showDoctorDetails(true);
                }
              } else if (props?.isDoctorDetails) {
                if (windowSize?.width < 767) {
                  props.showDoctorDetails && props.showDoctorDetails(true);
                }
              } else if (props?.isInstantGPDoctor) {
                props?.navigateToInstantGPScreen();
              } else if (props?.quickBooking) {
                sessionStorage.clear();
                props?.doctorDetails(e);
              }
            }}
          >
            {!props?.isFromFacilityDetail &&
            props?.doctorTenureLabel !== null &&
            props?.doctorTenureLabel !== undefined &&
            windowSize?.width > 782 ? (
              <div className="d-flex-column">
                <AsterIcons
                  legendsImage={props?.doctorTenureLabel === 'LEGEND' ? IC_LEGEND_PNG : IC_ICON_PNG}
                  lengendsText={props?.doctorTenureLabel === 'LEGEND' ? 'legends' : 'icons'}
                  infoIcon
                  customModal={false}
                  show={show}
                  onShowChange={(param)=>setShow(param)}
                />
                <div
                  className={
                    (props?.availableOfflineSlot === null && props?.availableOnlineSlot === null) ||
                    props?.showNearestSlot
                      ? 'doctorImage cursor-pointer mb-0'
                      : 'doctorImage cursor-pointer'
                  }
                >
                  <Image
                    src={
                      props?.image === '' || props?.image === undefined || props?.image === null
                        ? IC_DOCTOR.src
                        : props?.image
                    }
                    alt={props?.name}
                    width={!props.showNearestSlot ? '110' : '70'}
                    height={!props.showNearestSlot ? '110' : '70'}
                  />
                </div>
              </div>
            ) : (
              <div
                className={
                  (props?.availableOfflineSlot === null && props?.availableOnlineSlot === null) ||
                  props?.showNearestSlot
                    ? 'doctorImage cursor-pointer mb-0'
                    : 'doctorImage cursor-pointer'
                }
              >
                <Image
                  src={
                    props?.image === '' || props?.image === undefined || props?.image === null
                      ? IC_DOCTOR.src
                      : props?.image
                  }
                  alt={props?.name}
                  width={!props.showNearestSlot ? '110' : '70'}
                  height={!props.showNearestSlot ? '110' : '70'}
                />
              </div>
            )}
            <div className="doctorDetail">
              <div className="doctorName">
                <div className={props?.highlighKeyword ? 'name greyText cursor-pointer' : 'name cursor-pointer'}>
                  {props?.highlighKeyword ? (
                    <Highlighter
                      highlightTag={BoldSuggestion}
                      highlightClassName="searchText"
                      searchWords={[props?.highlighKeyword]}
                      autoEscape={true}
                      textToHighlight={props?.name}
                    />
                  ) : (
                    props?.name
                  )}
                </div>
                <div className="actionBlock d-flex">
                  {!props?.isGuest && !props?.isFromFacilityDetail && windowSize?.width > 782 && (
                    <div className="addToWishList">
                      <Form.Check
                        checked={props?.checked}
                        onClick={(e) => {
                          e.stopPropagation();
                          // props?.setLoading(true);
                          props.addRemoveFavorites();
                        }}
                        type="checkbox"
                      />
                    </div>
                  )}
                  {props?.shareIcon && windowSize?.width > 782 && (
                    <div className="share" ref={ref}>
                      <div className="share-tost">
                        <div className="filter">
                          <div className="ic">
                            <Image
                              data-test="shareIcon"
                              src={IC_SHARE.src}
                              width="18px"
                              height="20px"
                              alt="Share"
                              onClick={() => {
                                setClickOnShare(!isClickOnShare);
                              }}
                              style={{ cursor: 'pointer' }}
                            />
                          </div>
                          {isClickOnShare && <ShareProduct doctorName={props?.name} isFromDoctor={true} />}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="doctorSpecialty">
                {props?.highlighKeyword ? (
                  <Highlighter
                    highlightTag={BoldSuggestion}
                    highlightClassName="searchText"
                    searchWords={[props?.highlighKeyword]}
                    autoEscape={true}
                    textToHighlight={props?.specialist}
                  />
                ) : (
                  props?.specialist
                )}
              </div>
              {props?.languageText && <div className="languageKnown">Speaks&nbsp; {props?.languageText}</div>}
              {props?.addressWrapper && !props.showNearestSlot && (
                <div className="doctorAddress">
                  <div className="locationIcon">
                    <Image src={IC_LOCATION_DOCTORCARD} alt="" />
                  </div>
                  <div className="address" title={props?.location}>
                    {props?.location}
                  </div>
                  <div className="distance">
                    {props?.distance !== 'N/A' && <div className="fw-bold"> &nbsp;({props?.distance})</div>}
                  </div>
                  <div className="more ">{props?.more}</div>
                </div>
              )}
              {(props?.availableOfflineSlot !== null || props?.availableOnlineSlot !== null) &&
                !props.showNearestSlot && <hr className="d-none d-sm-block my-3 bottomLine" />}
            </div>
          </div>

          {props?.addressWrapper && props.showNearestSlot && !props?.isInstantGPDoctor && (
            <div className="doctorAddress Outside">
              <div className="locationIcon">
                <Image src={IC_LOCATION_DOCTORCARD} alt="" />
              </div>
              <div className="clinicAddress">
                <div className="address" title={props?.location}>
                  {props?.location}
                </div>
                <div className="distance">
                  {props?.distance !== 'N/A' && <div className="fw-bold"> {props?.distance}</div>}
                </div>
              </div>
              <div className="more ml-auto">{props?.more}</div>
            </div>
          )}

          {props.showNearestSlot && props?.isInstantGPDoctor && (
            <>
              <div className="mt-3 min-height-39">{t('InstantGP.headerTitle')}</div>
            </>
          )}

          {(props?.availableOfflineSlot !== null || props?.availableOnlineSlot !== null) && !props.showNearestSlot && (
            <hr className="d-block d-sm-none my-3 bottomLine" />
          )}
          {!props?.isDoctorDetails &&
            (props?.availableOfflineSlot !== null || props?.availableOnlineSlot !== null) &&
            !props.showNearestSlot && (
              <div
                className="viewMoreBlock cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  if (!props?.isDoctorDetails && !props?.quickBooking) {
                    sessionStorage.clear();
                    props?.doctorDetails(e);
                  }
                }}
              >
                <div>{t('InstantGP.nearestAvailable')}</div>
                {props?.isViewMore && (
                  <div
                    className="viewMore"
                    onClick={(e) => {
                      e.stopPropagation();
                      sessionStorage.clear();
                      props?.doctorDetails(e);
                    }}
                  >
                    {t('DoctorListing.viewMore')}
                  </div>
                )}
              </div>
            )}

          {!props?.isInstantGPDoctor && (
            <div className="appointmentType">
              <>
                {!props?.showNearestSlot ? (
                  <>
                    {props?.consulttype === 'Video Consultation' &&
                      props?.availableOnlineSlot &&
                      props?.availableOnlineSlot !== null && (
                        <div
                          className="box blueBox flex-grow-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (props?.quickBooking) {
                              props?.doctorDetailsBook();
                            } else {
                              setSlotDetails(props?.availableOnlineSlot, 'VIDEO');
                              props?.doctorDetails(e);
                            }
                          }}
                        >
                          <div className="consultIcon">
                            <Image src={IC_VIDEO_CALL_BLUE_BOX} alt="" />
                          </div>
                          <div className="flex-grow-1">
                            <div className="consultTitle">{t('DoctorListing.videoConsultation')}</div>
                            <div className="consultTime">
                              {props?.availableOnlineSlot?.slotStart
                                ? getCardDate(props?.availableOnlineSlot?.slotStart)
                                : getCardDate(props?.availableOnlineSlot)}
                            </div>
                          </div>
                          <div className="ms-2">
                            <div className="viewBtn">
                              <Image src={IC_RIGHT_ARROW} alt="" />
                            </div>
                          </div>
                        </div>
                      )}
                    {!props?.isVideoConsultation &&
                      props?.consultation === 'In-Person Consultation' &&
                      props?.availableOfflineSlot &&
                      props?.availableOfflineSlot !== null && (
                        <div
                          className="box greenBox flex-grow-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            if (props?.quickBooking) {
                              props?.doctorDetailsBook();
                            } else {
                              setSlotDetails(props?.availableOfflineSlot, 'IN_PERSON');
                              props?.doctorDetails(e);
                            }
                          }}
                        >
                          <div className="consultIcon">
                            <Image src={IC_INPERSON_GREEN} alt="" />
                          </div>
                          <div className="flex-grow-1">
                            <div className="consultTitle">{t('DoctorListing.inPersonConsultation')}</div>
                            <div className="consultTime">
                              {props?.availableOfflineSlot?.slotStart
                                ? getCardDate(props?.availableOfflineSlot?.slotStart)
                                : getCardDate(props?.availableOfflineSlot)}
                            </div>
                          </div>
                          <div className="ms-2">
                            <div className="viewBtn">
                              <Image src={IC_RIGHT_ARROW} alt="" />
                            </div>
                          </div>
                        </div>
                      )}
                  </>
                ) : (
                  <>
                    {(props?.availableOfflineSlot !== null || props?.availableOnlineSlot !== null) && (
                      <div className="box blueBox flex-grow-1 ">
                        <div
                          className="flex-grow-1"
                          onClick={(e) => {
                            e.stopPropagation();
                            setSlotDetails(getNearestSlotAvailable()?.slot, getNearestSlotAvailable()?.slotType);
                            props?.doctorDetails(e);
                          }}
                        >
                          <div className="consultTitle">{t('homeScreen.nearestAvailable')}</div>
                          <div className="consultTime">
                            {getNearestSlotAvailable()?.slot?.slotStart
                              ? getCardDate(getNearestSlotAvailable()?.slot?.slotStart)
                              : getCardDate(getNearestSlotAvailable()?.slot)}
                          </div>
                        </div>
                        <div className="ms-2">
                          <div className="viewBtn">
                            <Image src={IC_RIGHT_ARROW} alt="" />
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {props?.availableOfflineSlot === null && props?.availableOnlineSlot === null && (
                  <div
                    className="box greyBox flex-grow-1"
                    onClick={(e) => {
                      e.stopPropagation();
                      sessionStorage.setItem('isAvailable', 'true');
                      props?.doctorDetails(e);
                    }}
                  >
                    <div className="message">{t('DoctorDetails.noSlotAvailable')}</div>
                  </div>
                )}
              </>
            </div>
          )}
          {props.showNearestSlot && props?.isInstantGPDoctor && (
            <div className="appointmentType">
              <div
                className="box blueBox flex-grow-1 gpHeight"
                onClick={(e) => {
                  e.stopPropagation();
                  props?.navigateToInstantGPScreen();
                }}
              >
                <div className="flex-grow-1">
                  <div className="consultTime">{t('Prescription.bookInstantGP')}</div>
                </div>
                <div className="ms-2">
                  <div className="viewBtn">
                    <Image src={IC_RIGHT_ARROW} alt="" />
                  </div>
                </div>
              </div>
            </div>
          )}
        </Card.Body>
      </Card>
    </DoctorCardStyled>
  );
};

DoctorCard.propTypes = {
  image: PropTypes.any,
  distance: PropTypes.any,
  children: PropTypes.any,
  title: PropTypes.string,
  cardlabel: PropTypes.string,
  cardvariant: PropTypes.string,
  name: PropTypes.string,
  specialist: PropTypes.string,
  consultation: PropTypes.string,
  consulttype: PropTypes.string,
  location: PropTypes.string,
  more: PropTypes.string,
  checked: PropTypes.bool,
  btnWrapper: PropTypes.bool,
  addressWrapper: PropTypes.bool,
  sideName: PropTypes.bool,
  topName: PropTypes.bool,
  language: PropTypes.bool,
  languageText: PropTypes.string,
  availableTime: PropTypes.any,
  doctorDetails: PropTypes.any,
  doctorDetailsBook: PropTypes.func,
  addRemoveFavorites: PropTypes.func,
  isGuest: PropTypes.any,
  quickBooking: PropTypes.bool,
  shareIcon: PropTypes.any,
  btnOutside: PropTypes.bool,
  outerCustomClass: PropTypes.string,
  isViewMore: PropTypes.bool,
  availableOfflineSlot: PropTypes.any,
  availableOnlineSlot: PropTypes.any,
  isDoctorDetails: PropTypes.bool,
  highlighKeyword: PropTypes.string,
  showNearestSlot: PropTypes.bool,
  showDoctorDetails: PropTypes.bool,
  isVideoConsultation: PropTypes.bool,
  isInstantGPDoctor: PropTypes.bool,
  navigateToInstantGPScreen: PropTypes.func,
  inCompleteStatus: PropTypes.bool,
  setLoading: PropTypes.func,
  isFromDoctorDetails: PropTypes.bool,
};
DoctorCard.defaultProps = {
  btnWrapper: true,
  addressWrapper: true,
  sideName: true,
  topName: false,
  language: false,
  btnOutside: false,
  outerCustomClass: '',
  isViewMore: true,
  isDoctorDetails: false,
  quickBooking: false,
  highlighKeyword: '',
  showNearestSlot: false,
  showDoctorDetails: false,
  isInstantGPDoctor: false,
  isFromDoctorDetails: false,
};

export default DoctorCard;
